import { render, staticRenderFns } from "./printerRuleFees.vue?vue&type=template&id=33d899d5&scoped=true"
import script from "./printerRuleFees.vue?vue&type=script&lang=js"
export * from "./printerRuleFees.vue?vue&type=script&lang=js"
import style0 from "./printerRuleFees.vue?vue&type=style&index=0&id=33d899d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d899d5",
  null
  
)

export default component.exports